import { extractDomain } from "../utils";

// export const MIDDLEWARE = "/edge/dashboard/middleware";
export const MIDDLEWARE = "/edge/managejobposting/middleware";
// export const RECRUITER_ACTIONS_MIDDLEWARE = "/edge/foldermanagement/recruiter-actions-middleware"

export const ENDPOINTS = {
  getCandidatePipeline:
    "/edge-folder-management/api/v2/folder/candidate-pipeline",
  jobs: "/edge_mjp/jobs",
  deleteJob: "/edge-dashboard/api/v2/job/delete",
  expireJob: "/edge_mjp/expireJob",
  renewJob: "/edge_mjp/renewJob",
  renewJobDetails: "/edge_mjp/renewJobDetail",
  getHeader: "/recruiter4chat/common/get/header",
  getUserData: "/cassowary/session/getuser",
  downloadExcel: "/edge-folder-management/recruiter/v2/downloadExcel",
  discardDraft: "/edge_mjp/discardDraft",
  checkInventory: "/edge-folder-management/api/excel/inventory",
  getDownloadProfilesPolling :'/edge-folder-management/api/polling/excel',
  checkEmail:"/edge-folder-management/api/excel/mail",
  downloadExcelNew:"/edge-folder-management/recruiter/v3/downloadExcel",
  healthTracker: "/recruiter-edge-event-tracking/api/v1/tracking/page/load/event",
};

export const API_HEADERS: HeadersInit | undefined = {
  domain: extractDomain(),
};
